<template>
  <v-container
    fluid
    cols="12"
    class="d-flex"
  >
    <v-layout
      row
      wrap
    >
      <template
        v-if="payout.security"
      >
        <v-flex xs6>
          <!-- Security DETAILS START -->
          <v-card
            class="ma-2"
          >
            <v-card-title class="toolbar success white--text subheading">
              <span>Security: </span>
              <v-chip
                class="ma-2 white--text"
                color="primary"
              >
                {{ payout.security.name }}
              </v-chip>
            </v-card-title>

            <v-card-text>
              <v-layout
                wrap
                class="pa-0"
              >
                <v-flex
                  v-for="field in cleanFields(payout.security)"
                  :key="field"
                  class="pa-2"
                  xs6
                >
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <span>
                        <v-text-field
                          :label="field"
                          :value="payout.security[field]"
                          readonly
                          class="body-1"
                          :class="field"
                        />
                      </span>
                    </template>
                    <span>
                      field: {{ field }}
                    </span>
                  </v-tooltip>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
          <!-- Security DETAILS END -->
        </v-flex>
      </template>
      <template
        v-if="issuer"
      >
        <v-flex xs6>
          <!-- Issuer DETAILS START -->
          <v-card
            class="ma-2"
            xs6
          >
            <v-card-title class="toolbar success white--text subheading">
              <span>{{ issuerName }}: </span>
              <v-chip
                class="ma-2 white--text"
                color="primary"
              >
                {{
                  issuer ? issuer.company_name : 'Not available'
                }}
              </v-chip>
            </v-card-title>

            <v-card-text
              v-if="issuer"
            >
              <v-layout
                wrap
                class="pa-0"
              >
                <v-flex
                  v-for="field in cleanFields(issuer)"
                  :key="field"
                  class="pa-2"
                  xs6
                >
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <span>
                        <v-text-field
                          :label="field"
                          :value="issuer[field]"
                          readonly
                          class="body-1"
                          :class="field"
                        />
                      </span>
                    </template>
                    <span>
                      field: {{ field }}
                    </span>
                  </v-tooltip>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
          <!-- Issuer DETAILS END -->
        </v-flex>
      </template>
      <v-flex
        xs12
      >
        <v-btn
          dark
          flat
          block
          color="primary"
          @click.stop="() => setDebugPayout()"
        >
          <v-icon
            class="pr-2"
          >
            adb
          </v-icon>
          Debug
        </v-btn>
      </v-flex>
      <v-flex
        v-if="showHolders"
        xs12
      >
        <template
          v-if="holders"
        >
          <v-container
            fluid
            grid-list-md
          >
            <v-btn
              v-if="showTaxCalculationRetryAction"
              dark
              flat
              color="primary"
              @click.stop="() => retryAllHolderTaxCalculation()"
            >
              <v-icon>cached</v-icon>
              Retry All Tax Calculations
            </v-btn>
            <v-btn
              v-if="showAddressRetryAction"
              dark
              flat
              color="primary"
              @click.stop="() => retryAllHolderAddressEnrichment()"
            >
              <v-icon>cached</v-icon>
              Retry All Address Enrichments
            </v-btn>
            <v-btn
              v-if="showBankInformationRetryAction"
              dark
              flat
              color="primary"
              @click.stop="() => retryAllHolderBankInformationEnrichment()"
            >
              <v-icon>cached</v-icon>
              Retry All Bank Information Enrichments
            </v-btn>
            <v-divider class="mb-3" />
            <v-card-title>
              <v-spacer />
              <v-text-field
                v-model="searchHolder"
                append-icon="search"
                label="Filter Holder"
              />
            </v-card-title>
            <v-data-iterator
              :items="filteredHolders"
              :rows-per-page-items="rowsPerPageItems"
              :pagination.sync="pagination"
              content-tag="v-layout"
              row
              wrap
            >
              <template v-slot:item="props">
                <v-flex
                  xs12
                  sm6
                  md4
                  lg3
                >
                  <v-card>
                    <v-card-title>
                      <h4>
                        Holder:
                        <v-btn
                          style="text-transform: none;"
                          outline
                          round
                          color="grey"
                          :href="`/#/users/${props.item.user_id}`"
                        >
                          <v-icon>
                            assignment_ind
                          </v-icon>
                          {{ props.item.user_id }}
                        </v-btn>
                        <span
                          class="d-block font-weight-light"
                        >
                          ID: {{ props.item.id }}
                        </span>
                        <span
                          v-if="props.item.subinvestor_id"
                          class="font-weight-light"
                        >
                          Sub-Investor-ID: {{ props.item.subinvestor_id }}
                        </span>
                      </h4>
                    </v-card-title>
                    <v-divider />
                    <v-list dense>
                      <v-list-tile>
                        <v-list-tile-content>
                          <v-icon
                            color="blue"
                          >
                            settings
                          </v-icon>
                        </v-list-tile-content>
                        <v-list-tile-content class="align-end font-weight-bold">
                          General Information
                        </v-list-tile-content>
                      </v-list-tile>
                      <v-list-tile>
                        <v-list-tile-content>Pieces</v-list-tile-content>
                        <v-list-tile-content class="align-end">
                          {{ pieces(props.item) }}
                        </v-list-tile-content>
                      </v-list-tile>
                      <v-list-tile>
                        <v-list-tile-content>Type</v-list-tile-content>
                        <v-list-tile-content class="align-end">
                          {{ props.item.type || '-' }}
                        </v-list-tile-content>
                      </v-list-tile>
                      <v-list-tile>
                        <v-list-tile-content>Legal-Type</v-list-tile-content>
                        <v-list-tile-content class="align-end">
                          <v-icon
                            v-if="props.item.legal_type === 'legal_entity'"
                            color="grey"
                          >
                            account_balance
                          </v-icon>
                          <v-icon
                            v-else-if="props.item.legal_type === 'person'"
                            color="grey"
                          >
                            account_box
                          </v-icon>
                          <v-icon
                            v-else
                            color="grey"
                          >
                            help_center
                          </v-icon>
                        </v-list-tile-content>
                      </v-list-tile>
                      <template v-if="showHoldersPaybackInformation">
                        <v-list-tile>
                          <v-list-tile-content>
                            <v-icon
                              color="orange"
                            >
                              credit_card
                            </v-icon>
                          </v-list-tile-content>
                          <v-list-tile-content class="align-end font-weight-bold">
                            Payback Information
                          </v-list-tile-content>
                        </v-list-tile>
                        <v-list-tile>
                          <v-list-tile-content>Capital Gains Amount</v-list-tile-content>
                          <v-list-tile-content class="align-end">
                            {{ props.item.payback_information.capital_gains.total|toCurrency }}
                          </v-list-tile-content>
                        </v-list-tile>
                        <v-list-tile>
                          <v-list-tile-content>Gross Amount</v-list-tile-content>
                          <v-list-tile-content class="align-end">
                            {{ props.item.payback_information.gross_amount.total|toCurrency }}
                          </v-list-tile-content>
                        </v-list-tile>
                        <v-list-tile>
                          <v-list-tile-content>Net Amount</v-list-tile-content>
                          <v-list-tile-content class="align-end">
                            {{ props.item.payback_information.net_amount.total|toCurrency }}
                          </v-list-tile-content>
                        </v-list-tile>
                        <v-list-tile
                          v-if="props.item.payback_information.capital_gains_tax"
                        >
                          <v-list-tile-content>
                            Capital Gains Tax Amount
                            ({{
                              Number(
                                (props.item.payback_information.capital_gains_tax.percent * 100)
                                  .toFixed(2)
                              )
                            }}%)
                          </v-list-tile-content>
                          <v-list-tile-content class="align-end">
                            {{ props.item.payback_information.capital_gains_tax.total|toCurrency }}
                          </v-list-tile-content>
                        </v-list-tile>
                        <v-list-tile
                          v-if="props.item.payback_information.church_tax"
                        >
                          <v-list-tile-content>
                            Church Tax Amount
                            ({{ (props.item.payback_information.church_tax.percent * 100) || 0 }}%)
                          </v-list-tile-content>
                          <v-list-tile-content class="align-end">
                            {{ props.item.payback_information.church_tax.total|toCurrency }}
                          </v-list-tile-content>
                        </v-list-tile>
                        <v-list-tile
                          v-if="props.item.payback_information.solidary_tax"
                        >
                          <v-list-tile-content>
                            Solidary Tax Amount
                            ({{
                              props.item.payback_information.solidary_tax.percent
                                ? props.item.payback_information.solidary_tax.percent
                                  * 100
                                : 0
                            }}%)
                          </v-list-tile-content>
                          <v-list-tile-content class="align-end">
                            {{ props.item.payback_information.solidary_tax.total|toCurrency }}
                          </v-list-tile-content>
                        </v-list-tile>
                        <payment-information
                          :payment-information="props.item.payment_information"
                        />
                      </template>
                      <template v-if="showHoldersAddress">
                        <v-list-tile>
                          <v-list-tile-content>
                            <v-icon
                              color="green"
                            >
                              location_on
                            </v-icon>
                          </v-list-tile-content>
                          <v-list-tile-content class="align-end font-weight-bold">
                            Address Information
                          </v-list-tile-content>
                        </v-list-tile>
                        <v-list-tile
                          v-if="props.item.legal_type === 'legal_entity'"
                        >
                          <v-list-tile-content>Company Name</v-list-tile-content>
                          <v-list-tile-content class="align-end">
                            {{
                              props.item.address
                                ? props.item.address.company_name
                                : '-'
                            }}
                          </v-list-tile-content>
                        </v-list-tile>
                        <v-list-tile
                          v-if="props.item.legal_type === 'legal_entity'"
                        >
                          <v-list-tile-content>Company Type</v-list-tile-content>
                          <v-list-tile-content class="align-end">
                            {{
                              props.item.address
                                ? props.item.address.company_type
                                : '-'
                            }}
                          </v-list-tile-content>
                        </v-list-tile>
                        <v-list-tile
                          v-if="props.item.legal_type === 'person'"
                        >
                          <v-list-tile-content>Name</v-list-tile-content>
                          <v-list-tile-content class="align-end">
                            {{
                              props.item.address
                                ? props.item.address.first_name
                                : '-'
                            }}
                            {{
                              props.item.address
                                ? props.item.address.last_name
                                : '-'
                            }}
                          </v-list-tile-content>
                        </v-list-tile>
                        <v-list-tile>
                          <v-list-tile-content>Country, City</v-list-tile-content>
                          <v-list-tile-content class="align-end">
                            {{
                              props.item.address
                                ? props.item.address.country
                                : '-'
                            }}
                            {{
                              props.item.address
                                ? props.item.address.postal_code
                                : '-'
                            }}
                            {{
                              props.item.address
                                ? props.item.address.city
                                : '-'
                            }}
                          </v-list-tile-content>
                        </v-list-tile>
                        <v-list-tile>
                          <v-list-tile-content>Street</v-list-tile-content>
                          <v-list-tile-content class="align-end">
                            {{
                              props.item.address
                                ? props.item.address.street
                                : '-'
                            }}
                            {{
                              props.item.address
                                ? props.item.address.street_no
                                : '-'
                            }}
                          </v-list-tile-content>
                        </v-list-tile>
                      </template>
                      <v-divider />
                      <v-card-title>
                        <v-expansion-panel>
                          <v-expansion-panel-content>
                            <template v-slot:actions>
                              <v-icon color="orange">
                                task_alt
                              </v-icon>
                            </template>
                            <template v-slot:header>
                              <div>Actions</div>
                            </template>
                            <v-card>
                              <v-btn
                                v-if="allowToDeleteHolders"
                                dark
                                flat
                                block
                                color="primary"
                                @click.stop="() => showHolderDeleteDialog(props.item)"
                              >
                                <v-icon
                                  class="pr-2"
                                >
                                  delete
                                </v-icon>
                                Delete
                              </v-btn>
                              <v-btn
                                v-if="showPdfDownloadAction && props.item.pdf"
                                dark
                                flat
                                block
                                color="primary"
                                @click.stop="() => downloadPdf(props.item.id, props.item.type)"
                              >
                                <v-icon
                                  class="pr-2"
                                >
                                  download
                                </v-icon>
                                PDF
                              </v-btn>
                              <v-btn
                                dark
                                flat
                                block
                                color="primary"
                                @click.stop="() => setDebugHolder(props.item)"
                              >
                                <v-icon
                                  class="pr-2"
                                >
                                  adb
                                </v-icon>
                                Debug
                              </v-btn>
                            </v-card>
                          </v-expansion-panel-content>
                          <v-expansion-panel-content
                            v-if="replayActionIsAvailable"
                          >
                            <template v-slot:actions>
                              <v-icon color="orange">
                                cached
                              </v-icon>
                            </template>
                            <template v-slot:header>
                              <div>Replay Events</div>
                            </template>
                            <v-card>
                              <v-btn
                                v-if="showSetPeriodRetryAction
                                  && isNotLoanPayout(payout)"
                                dark
                                flat
                                block
                                color="primary"
                                @click.stop="() => retryHolderEvent(
                                  props.item,
                                  'holder-set-period-retry'
                                )"
                              >
                                <v-icon
                                  class="pr-2"
                                >
                                  schedule
                                </v-icon>
                                Set Period
                              </v-btn>
                              <v-btn
                                v-if="showCalcGrossamountRetryAction
                                  && isNotLoanPayout(payout)"
                                dark
                                flat
                                block
                                color="primary"
                                @click.stop="() => retryHolderEvent(
                                  props.item,
                                  'holder-calculate-gross-amount-retry'
                                )"
                              >
                                <v-icon
                                  class="pr-2"
                                >
                                  euro_symbol
                                </v-icon>
                                Calc Grossamount
                              </v-btn>
                              <v-btn
                                v-if="showTaxTraitEnrichmentRetryAction"
                                dark
                                flat
                                block
                                color="primary"
                                @click.stop="() => retryHolderEvent(
                                  props.item,
                                  'tax-trait-enrichment-retry'
                                )"
                              >
                                <v-icon
                                  class="pr-2"
                                >
                                  analytics
                                </v-icon>
                                Taxtrait Enrichment
                              </v-btn>
                              <v-btn
                                v-if="showTaxCalculationRetryAction"
                                dark
                                flat
                                block
                                color="primary"
                                @click.stop="() => retryHolderEvent(
                                  props.item,
                                  'tax-calculation-retry'
                                )"
                              >
                                <v-icon
                                  class="pr-2"
                                >
                                  calculate
                                </v-icon>
                                Tax Calculation
                              </v-btn>
                              <v-btn
                                v-if="showAddressRetryAction
                                  && isNotLoanPayout(payout)"
                                dark
                                flat
                                block
                                color="primary"
                                @click.stop="() => retryHolderEvent(
                                  props.item,
                                  'address-enrichment-retry'
                                )"
                              >
                                <v-icon
                                  class="pr-2"
                                >
                                  room
                                </v-icon>
                                Address Enrichment
                              </v-btn>
                              <v-btn
                                v-if="showBankInformationRetryAction
                                  && isNotLoanPayout(payout)"
                                dark
                                flat
                                block
                                color="primary"
                                @click.stop="() => retryHolderEvent(
                                  props.item,
                                  'bank-information-enrichment-retry'
                                )"
                              >
                                <v-icon
                                  class="pr-2"
                                >
                                  account_balance
                                </v-icon>
                                Bank Information Enrichment
                              </v-btn>
                            </v-card>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                      </v-card-title>
                    </v-list>
                  </v-card>
                </v-flex>
              </template>
            </v-data-iterator>
          </v-container>
        </template>
        <template v-else>
          No holders available.
        </template>
      </v-flex>
    </v-layout>
    <DebugDialog
      :visible="isDebugDialogActive"
      :debug-object="debugObject"
      :title="debugTitle"
      @close="isDebugDialogActive = false"
    />
    <v-snackbar
      v-model="snackbarShow"
      :color="snackbarColor"
      :auto-height="true"
    >
      <ul v-if="snackbarErrors">
        <li
          v-for="snackbarError in snackbarErrors"
          :key="snackbarError.mesage"
        >
          {{ snackbarError.message }}
        </li>
      </ul>

      <div
        v-if="snackbarMessage"
      >
        {{ snackbarMessage }}
      </div>

      <v-btn
        color="primary"
        text
        @click="snackbarShow = false"
      >
        Close
      </v-btn>
    </v-snackbar>
    <HolderDeleteDialog
      key="holder_delete_dialog"
      :visible="isHolderDeleteDialogActive"
      :holder="holderToDelete"
      @close="isHolderDeleteDialogActive = false"
      @submit="onHolderDelete()"
    />
  </v-container>
</template>

<script>

import { base64toBlob, saveFile } from '@/helpers';
import PaymentInformation from '@/components/payoutsAndTaxes/payout/shared/PaymentInformation';
import DebugDialog from '@/components/payoutsAndTaxes/payout/dialogs/shared/DebugDialog';
import HolderDeleteDialog from '@/components/payoutsAndTaxes/payout/dialogs/payout/HolderDeleteDialog';

export default {
  name: 'PayoutDetails',
  components: {
    DebugDialog,
    PaymentInformation,
    HolderDeleteDialog,
  },
  props: {
    payoutId: {
      type: String,
      default: () => '',
    },
    payout: {
      type: Object,
      default: () => {},
    },
    holders: {
      type: Array,
      default: () => [],
    },
    showHolders: {
      type: Boolean,
      default: () => false,
    },
    showHoldersAddress: {
      type: Boolean,
      default: () => false,
    },
    showHoldersPaybackInformation: {
      type: Boolean,
      default: () => false,
    },
    showPdfDownloadAction: {
      type: Boolean,
      default: () => false,
    },
    showAddressRetryAction: {
      type: Boolean,
      default: () => false,
    },
    showBankInformationRetryAction: {
      type: Boolean,
      default: () => false,
    },
    showSetPeriodRetryAction: {
      type: Boolean,
      default: () => false,
    },
    showCalcGrossamountRetryAction: {
      type: Boolean,
      default: () => false,
    },
    showTaxCalculationRetryAction: {
      type: Boolean,
      default: () => false,
    },
    showTaxTraitEnrichmentRetryAction: {
      type: Boolean,
      default: () => false,
    },
    allowToDeleteHolders: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      snackbarShow: false,
      snackbarMessage: '',
      snackbarColor: 'error',
      snackbarErrors: [],
      rowsPerPageItems: [4, 8, 12],
      searchHolder: '',
      debugObject: {},
      debugTitle: '',
      isDebugDialogActive: false,
      isHolderDeleteDialogActive: false,
      holderToDelete: null,
      pagination: {
        rowsPerPage: 4,
      },
    };
  },
  computed: {
    issuer() {
      if (this.payout.paying_company) {
        return this.payout.paying_company;
      }

      return this.payout.security && this.payout.security.issuer;
    },
    issuerName() {
      if (this.payout.paying_company) {
        return 'Paying Company';
      }

      return 'Issuer';
    },
    replayActionIsAvailable() {
      return (this.showSetPeriodRetryAction && this.isNotLoanPayout(this.payout))
        || (this.showCalcGrossamountRetryAction && this.isNotLoanPayout(this.payout))
        || (this.showTaxCalculationRetryAction)
        || (this.showAddressRetryAction && this.isNotLoanPayout(this.payout))
        || (this.showBankInformationRetryAction && this.isNotLoanPayout(this.payout));
    },
    filteredHolders() {
      const { searchHolder } = this;

      return searchHolder.length < 1 ?
        this.holders :
        this.holders.filter((holder) => {
          let found = false;
          const searchString = searchHolder.toLowerCase();
          Object.keys(holder)
            .map((key) => {
              if (holder[key] && String(holder[key]).indexOf(searchHolder) > -1) {
                found = true;
              }

              return key;
            });
          if (holder.address) {
            Object.keys(holder.address)
              .map((key) => {
                if (holder.address[key] &&
                  String(holder.address[key]).toLowerCase().indexOf(searchString) > -1) {
                  found = true;
                }

                return key;
              });
            if (!found &&
              String(`${String(holder.address.first_name).toLowerCase()} ${String(holder.address.last_name).toLowerCase()}`)
                .indexOf(searchString) > -1) {
              found = true;
            }
          }

          return found;
        });
    },
  },
  methods: {
    pieces(item) {
      return (item.payback_information
          && item.payback_information.interest_determination_base
          && item.payback_information.interest_determination_base.details)
        ? (item.payback_information.interest_determination_base.details.pieces || '-')
        : '-';
    },
    /**
     * removes keys from object if value is falsy or typeof object
     */
    cleanFields(data) {
      return Object.keys(data).filter(field => !!data[field] && typeof data[field] !== 'object');
    },
    isNotLoanPayout(payout) {
      return payout.security ? payout.security.type !== 'loan' : true;
    },
    downloadPdf(holderId, holderType) {
      const data = {
        payoutId: this.payoutId,
        holderId,
        holderType,
      };

      this.$store
        .dispatch('fetchPayoutPdfServiceDownloadPdf', data)
        .then((response) => {
          saveFile(base64toBlob(response.data), `${response.headers['x-file-name'].replace('_pdf', '')}.pdf`);
        });
    },
    showHolderDeleteDialog(holder) {
      this.holderToDelete = holder;
      this.isHolderDeleteDialogActive = true;
    },
    onHolderDelete() {
      if (this.holderToDelete) {
        const data = {
          payout_id: this.holderToDelete.payout_id,
          id: this.holderToDelete.id,
          userId: this.holderToDelete.user_id,
          type: this.holderToDelete.type,
        };
        this.$store
          .dispatch('callDeleteHolder', data)
          .then(() => {
          });
      }
      this.isHolderDeleteDialogActive = false;
    },
    retryHolderEvent(holder, eventName) {
      const data = {
        holder,
        eventName,
      };

      this.$store
        .dispatch('callRetryEvent', data)
        .then(() => {
          this.snackbarShow = true;
          this.snackbarErrors = [];
          this.snackbarMessage = `Successfully triggered Event Replay '${eventName}' for Holder #${holder.id}`;
          this.snackbarColor = 'success';
        })
        .catch((error) => {
          this.snackbarShow = true;
          this.snackbarErrors = (error.response && error.response.data) ? error.response.data : 'Error';
          this.snackbarMessage = '';
          this.snackbarColor = 'error';
        });
    },
    retryAllHolderTaxCalculation() {
      this.$store
        .dispatch('callAllMissingTaxCalculation', this.payoutId)
        .then(() => {
        });
    },
    retryAllHolderAddressEnrichment() {
      this.$store
        .dispatch('callAllMissingAddressDataEnrichment', this.payoutId)
        .then(() => {
        });
    },
    retryAllHolderBankInformationEnrichment() {
      this.$store
        .dispatch('callAllBankInformationEnrichment', this.payoutId)
        .then(() => {
        });
    },
    setDebugHolder(holder) {
      this.debugObject = holder;
      this.debugTitle = 'Debug Holder Information';
      this.isDebugDialogActive = true;
    },
    setDebugPayout() {
      const payout = { ...this.payout };
      payout.holders = undefined;
      this.debugObject = payout;
      this.debugTitle = 'Debug Payout Information';
      this.isDebugDialogActive = true;
    },
  },
};
</script>
<style lang="scss" >
.v-data-iterator .v-list__tile{
  height: 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/payoutsAndTaxes/payout/shared/PayoutDetails.vue